// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const MeterbarIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="MeterbarIcon" ref={forwardedRef} {...props}>
      <path d="M10.875 2.875v2H18v10h-7.125v2a.875.875 0 0 1-1.75 0v-2H2v-10h7.125v-2a.875.875 0 1 1 1.75 0m5.625 10.5v-7h-5.625v7zm-9.504 0h2.129v-7H6.996z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const MeterbarIcon = /* @__PURE__ */ Object.assign(
  MeterbarIconComponent,
  { displayName: 'MeterbarIcon' },
);
